import { AppBar, makeStyles, Toolbar, Typography } from '@material-ui/core';
import * as React from 'react';
import { LoadingIndicator, UserMenu } from 'react-admin';
import { useContext } from 'react';
import { AppConfigContext } from '../config';
import MyMenu from './MyMenu';

const useStyles = makeStyles((theme) => ({
  title: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingRight: theme.spacing(1),
  },
  menuItems: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  devNote: {
    margin: 'auto',
    backgroundColor: 'red',
    color: 'white',
  },
}));

const MyAppBar = ({ color = 'secondary', ...props }) => {
  const classes = useStyles();
  const { REACT_APP_ENVIRONMENT } = useContext(AppConfigContext);

  return (
    <AppBar {...props} color={color} open={false}>
      <Toolbar variant="dense">
        <Typography variant="h6" color="inherit" className={classes.title} id="react-admin-title" />
        <MyMenu />
        {REACT_APP_ENVIRONMENT !== 'production' && (
          <Typography className={classes.devNote}>
            TESTOVACÍ VERZE - DATA JSOU IMPORTOVÁNA BEZ OBRÁZKU A NEAKTUÁLNÍ (5.3.2025){' '}
          </Typography>
        )}
        <div className={classes.menuItems}>
          <LoadingIndicator />
          {React.cloneElement(<UserMenu />, { logout: props.logout })}
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default MyAppBar;
